export default [{
    name: "Dublin",
    sites: [{
        id: "12345",
        name: "Test Site",
    }, ],
}, ];